import type { FC } from "react";
import React from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { type ConfigurableProduct, type StockStatusElements } from "@jti/fe-common";

import { isVisibleByStockStatus } from "@product-details/utils/stockStatus";

import { ProductConfigurableBlock } from "./ProductConfigurableBlock";

import "./ProdutConfigurables.scss";

type StockVisibilityConfig = {
  displayOutOfStock: boolean;
  displayAvailableInStores: boolean;
};

type ProductConfigurablesProps = {
  options: Array<{
    list: ConfigurableProduct[];
    categoryName: string;
  }>;
  currentId: string;
  stockStatusElements?: StockStatusElements;
};

const getOptions = (
  options: ConfigurableProduct[],
  stock: StockStatusElements | undefined,
  stockVisibility: StockVisibilityConfig
): ConfigurableProduct[] => {
  if (!stock) {
    return [];
  }

  return options.filter(({ sku }) => {
    if (!sku || !stock[sku]) {
      return false;
    }

    return isVisibleByStockStatus(stock[sku], stockVisibility);
  });
};

export const ProductConfigurables: FC<ProductConfigurablesProps> = ({ options, currentId, stockStatusElements }) => {
  const { displayOutOfStockVariants = false, displayAvailableInStoresVariants = false } = useConfig();

  if (!options || options?.length === 0) {
    return <React.Fragment />;
  }

  const stockVisibility: StockVisibilityConfig = {
    displayOutOfStock: displayOutOfStockVariants,
    displayAvailableInStores: displayAvailableInStoresVariants,
  };

  return (
    <div className={"product-configuration-block"}>
      {options.map(({ list, categoryName }) => (
        <ProductConfigurableBlock
          key={categoryName}
          label={categoryName}
          options={getOptions(list, stockStatusElements, stockVisibility)}
          stock={stockStatusElements}
          value={currentId}
        />
      ))}
    </div>
  );
};
